import { Flex, FlexProps, Icon, Link } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { NavLink } from 'react-router-dom';

interface NavItemProps extends FlexProps {
  isActive: boolean;
  icon: IconType;
  children: string;
  path: string;
  onClick?: () => void;
}
const NavItem = ({ icon, isActive, children, path, onClick, ...rest }: NavItemProps) => {
  return (
    <Link
      as={NavLink}
      to={path}
      onClick={onClick}
      style={{ textDecoration: 'none' }}
      _focus={{ boxShadow: 'none' }}
      _activeLink={{
        backgroundColor: '#0BC5EA',
        color: 'white',
      }}
      color="gray.600"
    >
      <Flex
        align="center"
        p={3}
        mx={3}
        my={1}
        borderRadius="lg"
        role="group"
        cursor="pointer"
        _hover={{
          bg: 'cyan.400',
          color: 'white',
        }}
        bg={isActive ? 'cyan.400' : 'transparent'}
        {...rest}
      >
        {icon && <Icon mr={2} fontSize="16" as={icon} />}
        {children}
      </Flex>
    </Link>
  );
};
export default NavItem;
